import { createClient } from '@supabase/supabase-js'
// ON-407: must run before createClient — snapshots the load URL (auth tokens,
// ?code=) before detectSessionInUrl consumes and strips it.
import './authReturn'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
